import { render, staticRenderFns } from "./CompanyPlans.vue?vue&type=template&id=3adc5444"
import script from "./CompanyPlans.vue?vue&type=script&lang=js"
export * from "./CompanyPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports